import { fb, validators } from 'form';

export function getCategoryEditModel(data) {

  const model = fb.group({
    categoryId: [data.categoryId || '', [], { type: 'hidden' }],
    categoryCode: [data.categoryCode || '', [], { type: 'text' }],
    categoryName: [data.categoryName || '', [validators.Required()], { type: 'text' }],
    categorySlug: [data.categorySlug || '', [validators.Required()], { type: 'text' }],
  })

  return model;
}
